import { QueryClient } from "@tanstack/react-query";
import {
  apiBaseUrl,
  createAttendeeApi,
  createHttpClient,
  createStaffApi,
  createSuperuserApi,
  isApiError,
} from "@rekati/api";
import { staffSession } from "../features/auth/session-store";

export const http = createHttpClient({
  baseUrl: apiBaseUrl(),
  getToken: staffSession.token,
  onUnauthorized: () => staffSession.clear(),
});

export const staffApi = createStaffApi(http);
export const superuserApi = createSuperuserApi(http);
/** The public routes the console also reads: the event (board header) and the brand. */
export const publicApi = createAttendeeApi(http);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, error) => count < 2 && (!isApiError(error) || error.isRetryable),
    },
    mutations: { retry: false },
  },
});

/*
 * A new sign-in (or sign-out) drops everything the previous login read, so a
 * cached `staff/me` from a superuser never hands its role to the admin or desk
 * login that follows on the same tab.
 */
let signedInToken = staffSession.token();
staffSession.subscribe(() => {
  const token = staffSession.token();
  if (token === signedInToken) return;
  signedInToken = token;
  queryClient.clear();
});
